import React from 'react';
import { theme } from '@xometry/xometry_loft';
import KebabMenu from '../../../components/KebabMenu';

export interface Props {
  handleClick: any;
}

const PaymentMethodKebabMenu = (props: Props) => {
  const { handleClick } = props;
  return (
    <KebabMenu
      width="200px"
      height="36px"
      margin="-8px 0 0 0"
      options={[
        {
          id: 1,
          optionText: 'Remove Payment Method',
          textCssStyleString: `color: ${theme.colors.darkBlues[90]}; line-height: ${theme.lineHeights[2]}; font-size: ${theme.fontSizes[0]}`,
          iconName: 'far fa-minus-circle',
          iconCssStyleString: `color: ${theme.colors.darkBlues[75]}; margin-right: ${theme.space[2]}; padding-top: 2px`,
          itemCssStyleString: 'align-items: center; justify-content: center;',
          handleClick: () => handleClick(),
        },
      ]}
    />
  );
};

export default PaymentMethodKebabMenu;
